var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ChartWrapper',_vm._b({staticClass:"container-gap",attrs:{"is-data-empty":_vm.isDataEmpty,"context":_vm.context}},'ChartWrapper',_vm.$props,false))
}
var staticRenderFns = []

export { render, staticRenderFns }